import { isIanaTimeZone, resolveDisplayTimeZone, type UserTimezoneMode } from '@aot-aiops/shared';

export type PortalTimezoneState = {
  timezoneMode: UserTimezoneMode;
  timeZone: string | null;
  workspaceTimeZone: string;
  browserTimeZone: string;
  resolvedTimeZone: string;
};

let activeTimeZone = 'UTC';

export function browserTimeZone(): string {
  const detected = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return isIanaTimeZone(detected) ? detected : 'UTC';
}

export function createTimezoneState(input: {
  timezoneMode?: UserTimezoneMode;
  timeZone?: string | null;
  workspaceTimeZone?: string | null;
}): PortalTimezoneState {
  const browser = browserTimeZone();
  const workspace = isIanaTimeZone(input.workspaceTimeZone) ? input.workspaceTimeZone : 'UTC';
  const timezoneMode = input.timezoneMode ?? 'AUTO_BROWSER';
  const resolvedTimeZone = resolveDisplayTimeZone({
    preference: { mode: timezoneMode, timeZone: input.timeZone },
    workspaceTimeZone: workspace,
    browserTimeZone: browser,
  });
  return {
    timezoneMode,
    timeZone: input.timeZone ?? null,
    workspaceTimeZone: workspace,
    browserTimeZone: browser,
    resolvedTimeZone,
  };
}

export function setActiveTimeZone(timeZone: string) {
  activeTimeZone = isIanaTimeZone(timeZone) ? timeZone : 'UTC';
}

export function getActiveTimeZone() {
  return activeTimeZone;
}

export function formatInActiveTimeZone(value: string | number | Date, withTime = true) {
  const date = value instanceof Date ? value : new Date(value);
  if (!Number.isFinite(date.getTime())) return '—';
  return new Intl.DateTimeFormat(
    undefined,
    withTime
      ? { dateStyle: 'medium', timeStyle: 'short', timeZone: activeTimeZone }
      : { dateStyle: 'medium', timeZone: activeTimeZone },
  ).format(date);
}
